// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1osr7","itemTitle":"ClientEmergencyInfo_itemTitle__Au87V","itemText":"ClientEmergencyInfo_itemText__AXITb"};